module.exports = __webpack_public_path__ + "media/images/lp_v6_header-668ef5c5bc43764feea34e2d599d54e8.webp";